const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the rating viewer component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('ratingViewer', ['Application', 'Authorization', 'Ratings', function (Application, Authorization, Ratings) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        content: '=',
        contentId: '=',
        contentType: '@',
        popup: '@?',
        triggerPopup: '=?',
        workshopInstance: '=?',
        title: '=?'
      },
      template: require('../../templates/directives/rating-viewer.html'),
      controller: ['$scope', function ($scope) {
        var acceptedTypes = ['Workshop', 'Media', 'Article', 'Track', 'ScormContent', 'ImportedContent', 'Assessment', 'Journey'];
        var self = this;
        self.user = Authorization.getAuthToken().user;
        self.ratingExists = false;
        self.display = false;
        self.displayPopup = false;
        self.selectedValue;
        self.feedback = '';
        self.ratingOptions = [];
        self.hoverItem = 0;

        self.submit = function() {
          if (!self.selectedValue) {
            Application.messaging.addMessage({type: 'error', duration: 5, text: 'Please select a rating before submitting'});
            return;
          }

          var rating = {
            user: self.user._id,
            content_id: $scope.contentId,
            content_type: $scope.contentType,
            feedback: self.feedback,
            rating: self.selectedValue,
            total: self.configuration.total_value || 5
          };

          if ($scope.workshopInstance) {
            rating.context = [{name: 'workshop_instance', value: $scope.workshopInstance}];
          }

          Ratings.create(rating).$promise
          .then(function(results) {
            self.ratingExists = true;
            self.existingRating = {rating: self.selectedValue};
            self.display = false;
            self.displayPopup = false;
            Application.messaging.addMessage({type: 'success', duration: 5, text: 'Thanks for your feedback!'});
          }).catch(function(error) {
            Application.messaging.addMessage({type: 'error', duration: 5, text: 'There was an issue capturing your feedback. Please try again later.'});
          });
        };

        var setPopup = function() {
          if ($scope.popup !== 'true') {
            return;
          }

          if (self.ratingExists && !self.configuration.allow_edits) {
            return;
          }

          if ($scope.triggerPopup && self.configuration.allow_rating) {
            self.displayPopup = true;
            $scope.triggerPopup = false;
          }

          $scope.$watch('triggerPopup', function(newVal, oldVal) {
            if (!self.configuration.allow_rating || (self.ratingExists && !self.configuration.allow_edits)) {
              return;
            }

            if (newVal && !oldVal) {
              self.displayPopup = true;
              $scope.triggerPopup = false;
            }
          });
        };

        self.initialize = function() {
          self.configuration = $scope.content && $scope.content.rating_configuration;
          if (!$scope.contentType || !$scope.contentId || !self.user._id || !self.configuration) {
            return;
          }

          if (acceptedTypes.indexOf($scope.contentType) === -1) {
            console.log('Invalid content type passed to rating component');
            return;
          }

          self.ratingOptions = new Array(self.configuration.total_value);

          Ratings.find({
            content_id: $scope.contentId,
            user: self.user._id
          }).$promise.then(function(results) {
            if (results && results.length) {
              self.ratingExists = true;
              self.existingRating = results[0];
              if (self.configuration.allow_edits) {
                setPopup();
                self.display = true;
              }
              return;
            }

            if (!self.configuration.allow_rating) {
              return;
            }

            setPopup();
            self.display = true;
          });
        };

        self.initialize();
      }],
      controllerAs: 'rate'
    };
  }]);
